import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { container } from '@Container';
import { TYPES } from '@Types';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ArmiesAction, ArmyListAction, FoldersAction } from '@Redux/actions';
import ArmyListMake from '@Builder/myArmyList/make/ArmyListMake';
import ArmyListClone from '@Builder/myArmyList/clone/ArmyListClone';
import ArmyListDelete from '@Builder/myArmyList/delete/ArmyListDelete';
import ArmyListEdit from '@Builder/myArmyList/edit/ArmyListEdit';
import ArmyListPaint from '@Builder/myArmyList/paint/ArmyListPaint';
import ArmyListExport from '@Builder/myArmyList/export/ArmyListExport';
import { Breadcrumb, BreadcrumbItem, Col, Row } from 'reactstrap';
import ArmyListPrivate from '@Builder/myArmyList/common/ArmyListPrivate';
import MinimalArmyListMake from '@Builder/myArmyList/minimal/MinimalArmyListMake';
import { armyListPresenter } from '@Selectors/builder/myArmyList/common/armyListPresenter';
import ArmyListSupportComponent from '@Components/builder/army-list-support/army-list-support.component';
import ArmyListOrganisations from '@Builder/myArmyList/make/army-list-organisations';
import { FormattedMessage } from 'react-intl';
import { ArmyListActionState } from '@Stores/builder/ArmyListState';
import armyListSlice from '@Redux/reducers/builder/armyList.slice';

const ArmyListPageMake: React.FC<ArmyListPageMakeProps> = (
  {
    armyList,
    request,
    load,
    action,
  }) => {
  const params = useParams();
  const armyListId = params.army_list_id;

  const query = new URLSearchParams(useLocation().search);
  const useMinimal = query.get('minimal') === 'true';

  if (!armyListId) {
    return <div>
      Army List not found!
    </div>;
  }

  React.useEffect(() => {
    load(armyListId);
  }, []);

  const body = document.body;
  body.classList.remove('theme-default')
  body.classList.add(`theme-${armyList.game}`);


  let content = <ArmyListMake />;
  let toggleBuilder = '?minimal=true';
  if (useMinimal) {
    content = <MinimalArmyListMake />;
    toggleBuilder = '?minimal=false';
  }

  if (request.clone) content = <ArmyListClone />;
  if (request.delete) content = <ArmyListDelete />;
  if (request.edit) content = <ArmyListEdit />;
  if (request.paint) content = <ArmyListPaint />;
  if (request.export) content = <ArmyListExport />;

  return <div>
    <Row className="army_list">
      <Col xs={6} md={2} className="order-1 order-md-1 mt-1 text-center">
        <a href="#" onClick={() => action.toMake()}><i className="fas fa-clipboard-list fa-2x" /></a>
        <a href="#" onClick={() => action.toExport()} className="ms-1"><i className="fas fa-print fa-2x" /></a>
      </Col>

      <Col xs={12} md={8} className="order-3 order-md-2 mt-1 d-flex flex-row">
        {armyList.army?.logo &&
          <img src={armyList.army?.logo} alt={armyList.army?.name} height={75} className="float-start mt-2" />}
        <div className="ms-1 ms-md-3">
          <h3>{armyList.name} <span
            className="army-list-point small-text ms-2">{armyList.points} / {armyList.max} pts</span></h3>
          <small>{armyList.army?.name}{armyList.size != '' && (<> (<FormattedMessage id={armyList.size} />)</>)}</small>
        </div>
        {!useMinimal && (
          <div className="d-none d-lg-block">
            <ArmyListOrganisations />
          </div>
        )}
      </Col>

      <Col xs={6} md={2} className="order-2 order-md-3 mt-1 mb-1 text-center">
        <a href={toggleBuilder}><i className="fa-solid fa-minimize fa-2x"></i></a>
        <a href="#" onClick={() => action.toClone()} className="ms-1"><i className="fas fa-clone fa-2x" /></a>
        {!armyList.isUsed &&
          <a href="#" onClick={() => action.toDelete()} className="ms-1"><i className="fas fa-trash fa-2x" /></a>}
        {!armyList.isUsed &&
          <a href="#" onClick={() => action.toEdit()} className="ms-1"><i className="fas fa-edit fa-2x" /></a>}
        <a href="#" onClick={() => action.toPaint()} className="ms-1"><i className="fas fa-paint-brush fa-2x" /></a>
      </Col>
    </Row>

    <Breadcrumb>
      <BreadcrumbItem>
        <Link to={`/${document.documentElement.lang}/builder/army_lists`}>
          <i className="fa-solid fa-house"></i>
        </Link>
      </BreadcrumbItem>
      {armyList.folder !== null &&
        <BreadcrumbItem>
          <Link
            to={`/${document.documentElement.lang}/builder/folders/${armyList.folder.id}`}>Folder: {armyList.folder.name}</Link>
        </BreadcrumbItem>}
      <BreadcrumbItem active>{armyList.name}</BreadcrumbItem>
    </Breadcrumb>

    {/*<p><FormattedMessage id={'army_list.show.builder_interface'} /></p>*/}

    <ArmyListPrivate />

    {content}

    <ArmyListSupportComponent />
  </div>;
};

const mapStateToProps = (state: AppState) => ({
  armyList: armyListPresenter(state),
  request: {
    clone: ArmyListActionState.Clone === state.armyList.action,
    delete: ArmyListActionState.Delete === state.armyList.action,
    edit: ArmyListActionState.Edit === state.armyList.action,
    paint: ArmyListActionState.Paint === state.armyList.action,
    export: ArmyListActionState.Export === state.armyList.action
  }
});

const mapDispatchToProps = (dispatch: Dispatch) => {

  const armiesAction = container.get<ArmiesAction>(TYPES.Actions.ArmiesAction);
  const foldersAction = container.get<FoldersAction>(TYPES.Actions.FoldersAction);
  const armyListAction = container.get<ArmyListAction>(TYPES.Actions.ArmyListAction);

  return {
    load: (id: string) => {
      dispatch(armyListAction.fetchData({ entityId: id }));
      dispatch(armiesAction.fetchData());
      dispatch(foldersAction.fetchData());
    },
    action: {
      toMake: () => dispatch(armyListSlice.actions.cancel()),
      toExport: () => dispatch(armyListSlice.actions.setRequest(ArmyListActionState.Export)),
      toClone: () => dispatch(armyListSlice.actions.setRequest(ArmyListActionState.Clone)),
      toDelete: () => dispatch(armyListSlice.actions.setRequest(ArmyListActionState.Delete)),
      toEdit: () => dispatch(armyListSlice.actions.setRequest(ArmyListActionState.Edit)),
      toPaint: () => dispatch(armyListSlice.actions.setRequest(ArmyListActionState.Paint)),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListPageMake);

type ArmyListPageMakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
